import { Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useCallback } from "react";
import FilesModal from "src/components/shared/_Modals/FilesModal/FilesModal";
import { useFilesModal } from "src/components/shared/_Modals/FilesModal/FilesModal.hooks";
import { type IFile } from "src/interfaces";

interface Props {
  files: IFile[] | undefined;
}

const ExportEntryFiles = ({ files }: Props) => {
  const [opened, { open, close }] = useDisclosure();

  const filesModalProps = useFilesModal(files ?? []);

  const getButtonText = useCallback(() => {
    let text = "Files";
    if (files?.length) {
      text += `: ${files.length}`;
    }
    return text;
  }, [files?.length]);

  return (
    <>
      <Button variant="outline" onClick={open}>
        {getButtonText()}
      </Button>

      <FilesModal opened={opened} close={close} {...filesModalProps} />
    </>
  );
};

export default ExportEntryFiles;
